/* eslint-disable react-hooks/exhaustive-deps */
import Chart from 'react-google-charts';
import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardText, Col, Container, Row } from 'reactstrap'
import './AdminDashboard.css'
import { useDispatch } from 'react-redux';
import { getDCData } from '../../actions/EpikBoxes';
import NotAssessableCommon from '../../components/NotAssessableCommon';

const AdminDashboard = () => {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();

  const [graphLosAngeles, setGraphLosAngeles] = useState([]);
  const [graphChicago, setGraphChicago] = useState([]);
  const [graphNewYork, setGraphNewYork] = useState([]);
  const [latency, setLatency] = useState([]);
  const [protectedData, setProtectedData] = useState(true);

  const getAdminDashboardData = async () => {
    const res = await dispatch(getDCData(token));

    if (res) {
      const losUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'la');
      const losRegistered = res.registeredEpikBoxCount.find(item => item._id === 'la');
      const chicagoUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'ch');
      const chicagoRegistered = res.registeredEpikBoxCount.find(item => item._id === 'ch');
      const newYorkUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'ny');
      const newYorkRegistered = res.registeredEpikBoxCount.find(item => item._id === 'ny');

      setLatency(res?.averageDatacenterLatency || []);
      const losAngelesData = [
        ['Task', 'Hours per Day'],
        ['Registered', losRegistered?.count || 0],
        ['UnRegistered', losUnRegistered?.count || 0]
      ]
      const chicagoData = [
        ['Task', 'Hours per Day'],
        ['Registered', chicagoRegistered?.count || 0],
        ['UnRegistered', chicagoUnRegistered?.count || 0]
      ]
      const newYorkData = [
        ['Task', 'Hours per Day'],
        ['Registered', newYorkRegistered?.count || 0],
        ['UnRegistered', newYorkUnRegistered?.count || 0]
      ]
      setGraphLosAngeles(losAngelesData);
      setGraphChicago(chicagoData);
      setGraphNewYork(newYorkData);
    }
  };

  useEffect(() => {
    getAdminDashboardData();
  }, []);

  const onSuccess = (status) => {
    setProtectedData(status);
  }

  const twoDecimal = (num) => {
    if (typeof num === 'string') {
      num = parseFloat(num);
    }
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  return (
    <Container fluid style={{ margin: 0 }}>
      <div className="viewContainer" style={{ marginTop: '20px' }}>
        {
          protectedData ? <NotAssessableCommon onSuccess={onSuccess} /> :
            <>
              <Row className="mt-3 ">
                <Col md={4} sm={12}>
                  <Chart
                    chartType="PieChart"
                    width="100%"
                    height="400px"
                    data={graphLosAngeles}
                    options={{
                      title: "Los Angeles Data Center Load",
                      pieHole: 0.4,
                      is3D: false,
                    }}
                  />
                </Col>
                <Col md={4} sm={12}>
                  <Chart
                    chartType="PieChart"
                    width="100%"
                    height="400px"
                    data={graphChicago}
                    options={{
                      title: "Chicago Data Center Load",
                      pieHole: 0.4,
                      is3D: false,
                    }}
                  />
                </Col>
                <Col md={4} sm={12}>
                  <Chart
                    chartType="PieChart"
                    width="100%"
                    height="400px"
                    data={graphNewYork}
                    options={{
                      title: "New York Data Center Load",
                      pieHole: 0.4,
                      is3D: false,
                    }}
                  />
                </Col>
                {/* <Col md={3} sm={12}>
            <Chart
              chartType="PieChart"
              width="100%"
              height="400px"
              data={data}
              options={{
                title: "Atlanta by Line Types",
                pieHole: 0.4,
                is3D: false,
              }}
            />
          </Col> */}
              </Row>
              <Row className="seperator" />
              <Row className="mt-3">
                <Col md={12} sm={12} className="d-flex justify-content-around align-items-center ">
                  <Card
                    className="my-2"
                    color="info"
                    outline
                    style={{
                      width: '18rem'
                    }}
                  >
                    <CardHeader tag="h3">
                      Los Angeles Average Data Center Latency
                    </CardHeader>
                    <CardBody>
                      <CardText tag="h6">
                        {latency[0]?.laPingAvg ? twoDecimal(latency[0]?.laPingAvg) + `ms` : `N/A`}
                      </CardText>
                    </CardBody>
                  </Card>
                  <Card
                    className="my-2"
                    color="info"
                    outline
                    style={{
                      width: '18rem'
                    }}
                  >
                    <CardHeader tag="h3">
                      Chicago Average Data Center Latency
                    </CardHeader>
                    <CardBody>
                      <CardText tag="h6">
                        {latency[0]?.chPingAvg ? twoDecimal(latency[0]?.chPingAvg) + `ms` : `N/A`}
                      </CardText>
                    </CardBody>
                  </Card>
                  <Card
                    className="my-2"
                    color="info"
                    outline
                    style={{
                      width: '18rem'
                    }}
                  >
                    <CardHeader tag="h3">
                      New York Average Data Center Latency
                    </CardHeader>
                    <CardBody>
                      <CardText tag="h6">
                        {latency[0]?.nyPingAvg ? twoDecimal(latency[0]?.nyPingAvg) + `ms` : `N/A`}
                      </CardText>
                    </CardBody>
                  </Card>
                  {/* <Card
              className="my-2"
              color="info"
              outline
              style={{
                width: '18rem'
              }}
            >
              <CardHeader tag="h3">
                Atlanta Data Center Latency
              </CardHeader>
              <CardBody>
                <CardText tag="h6">
                  242ms
                </CardText>
              </CardBody>
            </Card> */}
                </Col>
              </Row>
            </>
        }
      </div>
    </Container>
  )
}

export default AdminDashboard
